export var JOB_STATUS_MAPPING={Open:"Accepted","On the way":"On the way",Started:"Arrived",Completed:"Completed",Failed:"Failed"};